<script setup>
import { computed } from 'vue';

const props = defineProps({
  contentAttributes: {
    type: Object,
    default: () => ({}),
  },
});

const isForwarded = computed(() => props.contentAttributes?.forwarded === true);
</script>

<template>
  <div
    v-if="isForwarded"
    class="flex items-center gap-1 text-xs text-n-slate-11 mb-1"
  >
    <span class="i-lucide-forward size-3" />
    <span>{{ $t('CONVERSATION.FORWARDED') }}</span>
  </div>
</template>
